import Service from '@ember/service';

import { service } from '@ember/service';
import { trackedFunction } from 'reactiveweb/function';

import { filterFilter, filterRename, filtersSort, filterTypes } from 'rise-ui/utils/model/filter.js';
import { latest } from 'rise-ui/utils/object/computed.js';

const hiddenFilters = filterTypes([ 'item-type', 'parameter' ]);
const filterOrder = filterTypes([
  // Uncomment and order as sort is desired
  // 'region',
  // 'location-type',
  // 'theme',
  // 'state',
  // 'item-type',
  // 'parameter',
  // 'parameter-group',
  // 'is-modeled',
  // 'unified-region',
]);

export default class TimeSeriesSearchFiltersService extends Service {
  @service('model/location-filters') locationFilters;
  @service ssr;

  filterFilter = filterFilter(hiddenFilters);
  filtersSort = filtersSort(filterOrder);

  _filters = trackedFunction(this, async () => {
    if (this.ssr.isSsr) {
      return this.ssr.FOREVER;
    }
    return (await this.locationFilters.fetch())
      .map(filterRename)
      .filter(this.filterFilter)
      .sort(this.filtersSort);
  });
  @latest('_filters') filters;
}
